<template>
  <div class="c-app">
    <TheSidebar />
    <div class="c-wrapper">
      <TheHeader />
      <div class="c-body">
        <main class="c-main">
          <CContainer fluid>
            <transition name="fade">
              <router-view></router-view>
            </transition>
          </CContainer>
        </main>
      </div>
    </div>
  </div>
</template>

<script>
import TheSidebar from "./TheSidebar";
import TheHeader from "./TheHeader";

export default {
  name: "TheContainer",
  components: {
    TheSidebar,
    TheHeader
  }

  // created() {
  //   this.validateToken() ? "" : this.$store.dispatch("clearToken");
  // },

  // watch: {
  //   $route() {
  //     this.validateToken() ? "" : this.$store.dispatch("clearToken");
  //   }
  // },
  // computed: {
  //   token() {
  //     return this.$store.state.token;
  //   }
  // },
  // methods: {
  //   validateToken() {
  //     const token = this.token;
  //     if (token) {
  //       try {
  //         const date = new Date(0);
  //         const decode = jwt_decode(token);
  //         date.setUTCSeconds(decode.exp);

  //         return date.valueOf() > new Date().valueOf();
  //       } catch (error) {
  //         return false;
  //       }
  //     } else {
  //       return false;
  //     }
  //   }
  // }
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
  transition: height 0.2s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
  transition: height 0s;
}
</style>
